<mat-card class="height-100">
  <mat-card-header fastHeaderFormat class="border-bottom">
    <app-fast-app-header
      class="w-100"
      [actionIsValid]="form.valid"
      [actionIsValid]="
        mostrarGrade && form.value.usa_grade
          ? form.valid && formVariacoesValid
          : form.valid
      "
      (submit)="salvar()"
      (back)="close()"
    >
      {{ produto.id ? 'Editar' : 'Adicionar' }} Produto
    </app-fast-app-header>
  </mat-card-header>
  <mat-card-content>
    <mat-tab-group>
      <mat-tab label="Dados" style="flex: 1;">
        <ng-template mat-tab-label>
          Dados
          <i
            *ngIf="formDadosValid"
            class="mdi mdi-alert-circle red"
            matTooltip="Preencha as informações corretamente"
          ></i>
        </ng-template>
        <div class="row m-0 pt-2">
          <!-- linha 1 -->
          <div class="flex-column mt-2 col-md-12">
            <mat-form-field class="width-100" appearance="outline">
              <mat-label>
                Código de barras
              </mat-label>
              <input
                matInput
                type="text"
                [formControl]="form.get('codigo_barra')"
              />
            </mat-form-field>
            <div class="flex flex-column">
              <small
                class="p-error"
                *ngIf="form.get('codigo_barra').hasError('existSpecialChar')"
              >
                Valor inválido, não aceita pontuação!
              </small>
              <small
                class="p-error"
                *ngIf="
                  form.get('codigo_barra').hasError('maxlength') &&
                  this.form.get('codigo_barra').touched
                "
              >
                Código de barra deve conter até 14 caracteres
              </small>
              <small
                class="p-error"
                *ngIf="
                  form.get('codigo_barra').hasError('minlength') &&
                  this.form.get('codigo_barra').touched
                "
              >
                Código de barra deve conter no mínimo 8 caracteres
              </small>
              <small
                class="p-error"
                *ngIf="
                  form.get('codigo_barra').hasError('repeated') &&
                  this.form.get('codigo_barra').touched
                "
              >
                Este código de barras já está em uso.
              </small>
              <small
                class="p-error"
                *ngIf="
                  form.get('codigo_barra').hasError('invalidCEAN') &&
                  this.form.get('codigo_barra').touched
                "
              >
                Código de barras inválido!
              </small>
              <small
                class="p-error"
                *ngIf="
                  form.get('codigo_barra').hasError('required') &&
                  this.form.get('codigo_barra').touched
                "
              >
                Código de barras obrigatório!
              </small>

              <mat-slide-toggle
                color="primary"
                [formControl]="form.get('validar_codigo_barra')"
                ngDefaultControl
                id="field-validar-cod-barras"
              >
                Validar código de barras
              </mat-slide-toggle>
            </div>
          </div>
          <!-- linha 2 -->
          <div class="flex-column mt-2 col-md-12">
            <mat-form-field class="width-100" appearance="outline">
              <mat-label>
                Descrição do produto
              </mat-label>
              <input
                matInput
                [readonly]="readOnly"
                type="text"
                [formControl]="form.get('descricao')"
              />
            </mat-form-field>
            <small
              class="p-error"
              *ngIf="
                form.get('descricao').hasError('maxlength') &&
                this.form.get('descricao').touched
              "
            >
              Campo descrição não deve conter mais que 60 caracteres
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('descricao').hasError('required') &&
                this.form.get('descricao').touched
              "
            >
              Descrição obrigatória
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('descricao').hasError('isEmptyValue') &&
                this.form.get('descricao').touched
              "
            >
              Valor inválido: remova os espaços em branco!
            </small>
          </div>
          <!-- linha 4 -->
          <fast-autocomplete
            #input
            [autoFirst]="false"
            id="field-fabricante"
            placeholder="Fabricante"
            required
            class="mt-2 col-md-12"
            [controlIsEnabled]="!produto.id"
            [readonly]="readOnly"
            displayField="parceiro.nome_razao_social"
            (clearSelection)="form.get('fabricante').reset()"
            [displayWithEntityFn]="parceiroDisplay"
            [messages]="{
              required: 'Fabricante é obrigatório',
              typeIs: 'Fabricante inválido'
            }"
            [control]="form.get('fabricante')"
            [domain_id]="tokenService.getDomain().id"
            [entityService]="fabricanteService"
            [include]="['parceiro']"
            [domainPath]="'parceiro.domain_id'"
            [pageValue]="'0'"
            [pageSizeValue]="'10'"
            [initDataWithEmpty]="true"
            [insertType]="'fabricante'"
          ></fast-autocomplete>
          <fast-autocomplete
            #input
            [autoFirst]="false"
            id="field-unidade"
            placeholder="Unidade"
            (clearSelection)="form.get('unidade').reset()"
            required
            class="mt-2 col-md-6"
            [controlIsEnabled]="!produto.id"
            [readonly]="readOnly"
            displayField="sigla"
            [messages]="{
              required: 'Unidade é requerida.',
              typeIs: 'Unidade inválida'
            }"
            [control]="form.get('unidade')"
            [entityService]="unidadeService"
            [initDataWithEmpty]="true"
            [insertType]="'unidade'"
            [value_order]="'nome'"
            [domain_id]="tokenService.getDomain().id"
            [pageValue]="'0'"
            [pageSizeValue]="'10'"
          ></fast-autocomplete>
          <!-- linha 3 -->
          <fast-autocomplete
            #input
            [autoFirst]="false"
            id="field-grupo"
            placeholder="Grupo"
            [controlIsEnabled]="!produto.id"
            [readonly]="readOnly"
            required
            (clearSelection)="form.get('grupo').reset()"
            class="mt-2 col-md-6"
            displayField="nome"
            [messages]="{
              required: 'Grupo é requerido.',
              typeIs: 'Grupo inválido'
            }"
            [control]="form.get('grupo')"
            [entityService]="grupoService"
            [initDataWithEmpty]="true"
            [insertType]="'grupo'"
            [value_order]="'nome'"
            [domain_id]="tokenService.getDomain().id"
            [pageValue]="'0'"
            [pageSizeValue]="'10'"
            [include]="['parent']"
            [displayWithEntityFn]="displayGrupo"
          ></fast-autocomplete>
          <!-- [actionState]="checkDisponibilidade('POST','','/fabricantes')" -->
          <!-- <div *ngIf="!produto.id" class="mt-2 col-md-4 mt-2">
            <mat-form-field class="width-100" appearance="outline">
              <mat-label>Quantidade</mat-label>
              <input
                matInput
                (keydown)="validateOnlyNumbers($event)"
                type="text"
                mask="separator.3"
                decimalMarker=","
                separatorLimit="100000000000"
                [allowNegativeNumbers]="true"
                [formControl]="form.get('quantidade')"
                style="text-align: right;"
              />
            </mat-form-field>
            <small
              class="p-error"
              *ngIf="
                form.get('quantidade').hasError('pattern') &&
                this.form.get('quantidade').touched
              "
            >
              A quantidade deve conter no máximo 13 digítos.
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('quantidade').hasError('required') &&
                this.form.get('quantidade').touched
              "
            >
              Valor de quantidade é obrigatória!
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('quantidade').hasError('existSpecialChar') &&
                this.form.get('quantidade').touched
              "
            >
              Valor inválido, não aceita pontuação!
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('quantidade').hasError('required') &&
                this.form.get('quantidade').touched
              "
            >
              Valor mínimo é obrigatório
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('quantidade').getError('max_value') &&
                this.form.get('quantidade').touched
              "
            >
              Inválido: passou dos limites
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('quantidade').getError('before_split') &&
                this.form.get('quantidade').touched
              "
            >
              Inválido: erro na parte inteira
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('quantidade').getError('after_split') &&
                this.form.get('quantidade').touched
              "
            >
              Inválido: erro na parte decimal
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('quantidade').getError('errorComma') &&
                this.form.get('quantidade').touched
              "
            >
              Inválido: excesso de virgulas
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('quantidade').getError('errorDots') &&
                this.form.get('quantidade').touched
              "
            >
              Inválido: excesso de pontos
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('quantidade').getError('notNumbers') &&
                this.form.get('quantidade').touched
              "
            >
              Inválido: insira um número
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('quantidade').getError('invalidNumber') &&
                this.form.get('quantidade').touched
              "
            >
              Valor inválido
            </small>
          </div> -->
          <div
            [class]="
              checkDisponibilidade('GET', '', '/variacoes') && !produto.id
                ? 'mt-2 col-md-4 mt-2'
                : 'mt-2 col-md-6 mt-2'
            "
          >
            <mat-form-field class="width-100" appearance="outline">
              <mat-label>Valor unitário</mat-label>
              <input
                matInput
                [readonly]="readOnly"
                (keydown)="validateOnlyNumbers($event)"
                type="text"
                [formControl]="form.get('valor_unitario')"
                style="text-align: right;"
              />
              <span matPrefix>R$&nbsp;</span>
            </mat-form-field>
            <small
              class="p-error"
              *ngIf="
                form.get('valor_unitario').hasError('existSpecialChar') &&
                this.form.get('valor_unitario').touched
              "
            >
              Valor inválido, não aceita pontuação!
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('valor_unitario').hasError('required') &&
                this.form.get('valor_unitario').touched
              "
            >
              Valor unitário é obrigatório
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('valor_unitario').getError('valueMinZero') &&
                this.form.get('valor_unitario').touched
              "
            >
              Valor não pode ser zero
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('valor_unitario').getError('max_value') &&
                this.form.get('valor_unitario').touched
              "
            >
              Inválido: passou dos limites
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('valor_unitario').getError('value_equals') &&
                this.form.get('valor_unitario').touched
              "
            >
              Valor não pode ser igual ao atual
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('valor_unitario').getError('before_split') &&
                this.form.get('valor_unitario').touched
              "
            >
              Inválido: erro na parte inteira
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('valor_unitario').getError('after_split') &&
                this.form.get('valor_unitario').touched
              "
            >
              Inválido: erro na parte decimal
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('valor_unitario').getError('errorComma') &&
                this.form.get('valor_unitario').touched
              "
            >
              Inválido: excesso de virgulas
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('valor_unitario').getError('errorDots') &&
                this.form.get('valor_unitario').touched
              "
            >
              Inválido: excesso de pontos
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('valor_unitario').getError('notNumbers') &&
                this.form.get('valor_unitario').touched
              "
            >
              Inválido: insira um número
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('valor_unitario').getError('menor_valor') &&
                this.form.get('valor_unitario').touched
              "
            >
              Valor menor que valor mínimo
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('valor_unitario').getError('invalidNumber') &&
                this.form.get('valor_unitario').touched
              "
            >
              Valor inválido
            </small>
          </div>
          <div
            [class]="
              checkDisponibilidade('GET', '', '/variacoes') && !produto.id
                ? 'mt-2 col-md-4 mt-2'
                : 'mt-2 col-md-6 mt-2'
            "
          >
            <mat-form-field class="width-100" appearance="outline">
              <mat-label>Valor mínimo</mat-label>
              <input
                matInput
                [readonly]="readOnly"
                (keydown)="validateOnlyNumbers($event)"
                type="text"
                [formControl]="form.get('valor_minimo')"
                style="text-align: right;"
              />
              <span matPrefix>R$&nbsp;</span>
            </mat-form-field>
            <small
              class="p-error"
              *ngIf="
                form.get('valor_minimo').hasError('existSpecialChar') &&
                this.form.get('valor_minimo').touched
              "
            >
              Valor inválido, não aceita pontuação!
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('valor_minimo').hasError('required') &&
                this.form.get('valor_minimo').touched
              "
            >
              Valor mínimo é obrigatório
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('valor_minimo').getError('valueMinZero') &&
                this.form.get('valor_minimo').touched
              "
            >
              Valor não pode ser zero
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('valor_minimo').getError('max_value') &&
                this.form.get('valor_minimo').touched
              "
            >
              Inválido: passou dos limites
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('valor_minimo').getError('value_equals') &&
                this.form.get('valor_minimo').touched
              "
            >
              Valor não pode ser igual ao atual
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('valor_minimo').getError('before_split') &&
                this.form.get('valor_minimo').touched
              "
            >
              Inválido: erro na parte inteira
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('valor_minimo').getError('after_split') &&
                this.form.get('valor_minimo').touched
              "
            >
              Inválido: erro na parte decimal
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('valor_minimo').getError('errorComma') &&
                this.form.get('valor_minimo').touched
              "
            >
              Inválido: excesso de virgulas
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('valor_minimo').getError('errorDots') &&
                this.form.get('valor_minimo').touched
              "
            >
              Inválido: excesso de pontos
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('valor_minimo').getError('notNumbers') &&
                this.form.get('valor_minimo').touched
              "
            >
              Inválido: insira um número
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('valor_minimo').getError('invalidNumber') &&
                this.form.get('valor_minimo').touched
              "
            >
              Valor inválido
            </small>
          </div>
          <div
            class="mt-2 col-md-3 mt-2"
            *ngIf="
              checkDisponibilidade('GET', '', '/variacoes') && mostrarGrade
            "
          >
            <mat-checkbox [formControl]="form.get('usa_grade')" color="primary">
              Aplicar grade no produto
            </mat-checkbox>
          </div>
        </div>
      </mat-tab>
      <mat-tab
        label="Info. catálogo"
        style="flex: 1;"
        *ngIf="checkDisponibilidade('POST', '', '/catalogos')"
      >
        <ng-template mat-tab-label>
          Info. catálogo
          <i
            *ngIf="formCatalogoValid"
            class="mdi mdi-alert-circle red"
            matTooltip="Preencha as informações corretamente"
          ></i>
        </ng-template>
        <div class="container">
          <div class="mt-2 col-md-12 mt-3 p-0">
            <span class="p-float-label">
              <textarea
                rows="5"
                cols="30"
                pInputTextarea
                [readonly]="readOnly"
                style="resize: none;"
                id="inputtext-descricao"
                [formControl]="form.get('descricao_completa')"
                class="input-filters"
              ></textarea>
              <label for="inputtext-descricao">Descrição geral</label>
            </span>
            <small
              class="p-error"
              *ngIf="
                form.get('descricao_completa').hasError('maxlength') &&
                this.form.get('descricao_completa').touched
              "
            >
              Campo descrição não deve conter mais que 200 caracteres
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('descricao_completa').hasError('isEmptyValue') &&
                this.form.get('descricao_completa').touched
              "
            >
              Valor inválido: remova os espaços em branco!
            </small>
          </div>
          <div class="mt-2 col-md-12 mt-3 p-0">
            <span class="p-float-label">
              <textarea
                rows="5"
                cols="30"
                pInputTextarea
                style="resize: none;"
                [readonly]="readOnly"
                id="inputtext-descricao"
                [formControl]="form.get('descricao_secundaria')"
                class="input-filters"
              ></textarea>
              <label for="inputtext-descricao">Descrição secundária</label>
            </span>
            <small
              class="p-error"
              *ngIf="
                form.get('descricao_secundaria').hasError('maxlength') &&
                this.form.get('descricao_secundaria').touched
              "
            >
              Campo descrição não deve conter mais que 50 caracteres
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('descricao_secundaria').hasError('isEmptyValue') &&
                this.form.get('descricao_secundaria').touched
              "
            >
              Valor inválido: remova os espaços em branco!
            </small>
          </div>
          <chip-input
            class="mt-2 col-md-12 p-0"
            style="width: 100% !important;"
            [initialValue]="tags"
            [readonly]="readOnly"
            (onChange)="changeTag($event)"
          ></chip-input>
        </div>
      </mat-tab>
      <mat-tab label="Preço">
        <button
          pButton
          pRipple
          [disabled]="produto.id"
          iconPos="right"
          (click)="editAddPrecoProduto()"
          label="Adicionar"
          icon="pi pi-plus"
          class="p-button-primary p-button-raised mt-3 ml-2"
        ></button>
        <mat-nav-list class="d-flex flex-wrap">
          <mat-list-item
            (click)="editAddPrecoProduto(preco)"
            class="mt-2 col-md-6"
            *ngFor="let preco of produtoPrecos; let i = index"
          >
            <mat-icon matListIcon>attach_money</mat-icon>
            <h3 matLine>{{ preco.tabela_preco.nome }}</h3>
            <p matLine>
              <span> {{ preco.valor | currency: 'BRL' }} </span>
            </p>
            <button
              type="button"
              mat-icon-button
              (click)="removePrecoProduto($event, i)"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </mat-list-item>
        </mat-nav-list>
      </mat-tab>
      <mat-tab
        label="Variações"
        style="flex: 1"
        *ngIf="form.value.usa_grade"
        [disabled]="
          form.get('descricao').value === null ||
          form.get('descricao').value === '' ||
          form.get('quantidade').value === null ||
          form.get('quantidade').value === '' ||
          form.get('valor_minimo').value === null ||
          form.get('valor_minimo').value === ''
        "
      >
        <app-form-produto-variacoes
          [entity]="produto"
          [updateRowsVariacao]="updateRowsVariacao"
          [valor_minimo]="form.get('valor_minimo').value"
          [descricao]="form.get('descricao').value"
          [quantidade]="form.get('quantidade').value"
          [codigo_barra]="form.get('codigo_barra').value"
          (clearVariacoes)="callUpdateSettings()"
        ></app-form-produto-variacoes>
      </mat-tab>
    </mat-tab-group>
  </mat-card-content>
</mat-card>
